/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import { DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule, ButtonModule } from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';

import {SearchModule} from "../../component/search.component";

import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {CommonModule} from "@angular/common";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS

@Component({

selector: 'lost-management',
templateUrl: 'lost_management.html'
})
export class LostManagementComponent implements OnInit {

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  selectedCompany : any;
  translate : TranslateServiceForm;
  ngOnInit() {

    this.getLostList(1,0,10,"","","");
  }

  constructor(private service: MamAdminService, private logger : Logger, private _translate: TranslateServiceForm) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LostUser'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LostTelNumber'), value: 'mobileNumber'});
    /*this.searchIDs.push({label: '단말유형', value: 'name'});*/
    /*this.searchIDs.push({label: '도난분실현황', value: 'lost'});*/
    /*this.searchIDs.push({label: '도난분실시간', value: 'lostTime'});
    this.searchIDs.push({label: '마지막전송일시', value: 'heartbeatDateTime'});*/

    this.dateIsTrue = false;

  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    /*if(!this.sDate || !this.eDate ) {
      alert("검색 날짜는 필수 조건 입니다.");
      return;
    }

    if(this.eDate < this.sDate ) {
      alert("검색 마지막 날짜는 시작 날짜 보다 작을 수 없습니다.");
      return;
    }*/

    this.getLostList(this.selectedCompany.id,0,this.pageMax,this.searchText, "true", this.searchId);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {

      this.getLostList(this.selectedCompany.id, event.page , event.rows,this.searchText, "true", this.searchId);
    } else {

      this.getLostList(this.selectedCompany.id, event.page , event.rows,"", '',"");
    }

  }

  recoverLostStolen(deviceId :number){

    this.getLostDeviceCommpandAct("find",deviceId);

  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.getLostList(this.selectedCompany.id,0,10,"","","");
    this.logger.debug("combo - select :" , this.selectedCompany);
  }



  getLostList(companyId:any, page:number, max:number, search:string, like:string, field:string) {
    this.service.getNewLostList(companyId, page, max, search, like, field).subscribe(
        value => {
            this.table_list = value.content;
            this.totalRecord = value.totalElements;
            this.logger.debug("-- device_lost_list : " , value);
        },
        error=>{
            this.logger.error("-- error : " + error);
        },
        ()=>{
            this.logger.info("-- complate : ");
        }
    )
  }

  getLostDeviceCommpandAct(commandType: string, deviceId: number) {
    this.service.getLostDeviceCommpandAct(commandType, deviceId).subscribe(
        value => {
          this.logger.debug("--value",value);
          let command = "FOUND";
          this.pushByDevice(command,'',deviceId);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
          this.getLostList(1, 1,10,"","","");
        }
    )
  }

  pushByDevice(command: string, value: string, device_ids: any) {
    this.service.remotePushByDevice(command, value, device_ids).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- RemotePushByDevice result : ", result);
          alert(this.translate.instant('Message_Alert_Success'));
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.getLostList(this.selectedCompany.id, 1,10,"","","");
          //this.getLostDeviceCommpandAct("find",device_ids);
        }
    )
  }



}

@NgModule({
  imports: [ DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule, ButtonModule, CompanyDropDownListModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [LostManagementComponent],
  declarations: [LostManagementComponent],
  providers: [],
})
export class LostManagementModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/lost_management.ts